import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';

const TextFieldWrapper = styled.div`
    margin: 0 0 20px 0;

    &>:nth-child(2) {
        margin: 0;
    }
`;

const Label = styled.div`
    margin-bottom: 3px;
    font-size: 14px;
    line-height: 1.2;
    font-weight: bold;
`;

const Text = styled.div`
    font-size: 16px;
    line-height: 1.2;
`;

const StatusTextField = (props) => {
    const {
        component,
        label,
        translate,
        uppercase,
        record,
        source,
    } = props;

    if (utils.isEmpty(record)) {
        return null;
    }

    if (component) {
        return (
            <TextFieldWrapper>
                { label &&
                    <Label>{ translate(label) || '...' }</Label>
                }

                { React.createElement(component, { record, source }) }
            </TextFieldWrapper>
        );
    }

    let formattedValue = record[source];

    if (uppercase && typeof formattedValue === 'string') {
        formattedValue = formattedValue.toUpperCase();
    }

    return (
        <TextFieldWrapper>
            { label &&
                <Label>{ translate(label) || '...' }</Label>
            }

            <Text>{ formattedValue }</Text>
        </TextFieldWrapper>
    );
};

StatusTextField.defaultProps = {
    uppercase: false,
    source: 'status',
};

StatusTextField.propTypes = {
    component: PropTypes.func,
    label: PropTypes.string,
    translate: PropTypes.func.isRequired,
    record: PropTypes.object.isRequired,
    source: PropTypes.string,
    uppercase: PropTypes.bool,
};

export default translate(StatusTextField);



// WEBPACK FOOTER //
// ./src/components/show/StatusTextField.js